import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Heart } from 'lucide-react';

const C = {
  cream: '#F5F1E8',
  gold: '#C6A96B',
  darkText: '#2C2C2C',
  darkTextSec: '#5A5A5A',
};

const fadeUp = {
  initial: { y: 20, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

const LpContactPage = () => (
  <div style={{ fontFamily: "'Manrope', sans-serif", background: C.cream, color: C.darkText, minHeight: '100vh' }}>
    <div className="max-w-xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <motion.div {...fadeUp} className="text-center">
        <img
          src="/sent2ment-logo.png"
          alt="Sent2ment"
          className="h-16 w-auto object-contain mx-auto mb-14"
        />

        <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Get in Touch</h1>
        <p className="text-base leading-relaxed mb-14 max-w-md mx-auto" style={{ color: C.darkTextSec }}>
          We're here to help with anything — whether you have a question about your order, need support with your upload, or simply want to say hello.
        </p>

        <div className="p-10 mb-12" style={{ background: '#FFFDF8', border: `1px solid ${C.gold}20` }}>
          <Mail className="mx-auto mb-5" size={28} strokeWidth={1.2} style={{ color: C.gold }} />
          <p className="text-xs tracking-[0.2em] uppercase mb-3 font-medium" style={{ color: C.gold }}>Email Us</p>
          <a href="mailto:hello@sent2ment.co.uk" className="text-lg font-light transition-colors duration-300 hover:text-[#C6A96B]" style={{ fontFamily: "'Cormorant Garamond', serif", color: C.darkText }}>
            hello@sent2ment.co.uk
          </a>
          <p className="text-xs mt-4 leading-relaxed" style={{ color: C.darkTextSec }}>
            We typically respond within 24 hours.
          </p>
        </div>

        <div className="mb-16">
          <p className="text-base leading-relaxed italic max-w-sm mx-auto" style={{ fontFamily: "'Cormorant Garamond', serif", color: C.darkTextSec }}>
            Every message matters to us — just as yours matters to the people you love.
          </p>
        </div>

        <Heart className="mx-auto mb-4" size={18} strokeWidth={1.2} style={{ color: `${C.gold}50` }} />

        <div className="border-t pt-8 mt-8" style={{ borderColor: `${C.gold}15` }}>
          <p className="text-xs italic mb-2" style={{ fontFamily: "'Cormorant Garamond', serif", color: C.gold }}>Sent2ment Ltd</p>
          <p className="text-[11px] leading-relaxed" style={{ color: `${C.darkTextSec}AA` }}>
            Sent2ment<sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>®</sup> is a registered trademark in the United Kingdom.
          </p>
        </div>
      </motion.div>
    </div>
  </div>
);

export default LpContactPage;
